import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const StyledWrapper = styled.div`
  font-size: ${({ theme }) => theme.font.size.sm};
  width: 100%;
  &:not(:first-child) {
    padding-top: ${({ theme }) => theme.space.lg};
  }
  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
    padding-bottom: ${({ theme }) => theme.space.lg};
  }
`;

export const StyledAcpLogo = styled.img`
  height: auto;
  object-fit: contain;
  margin-top: ${({ theme }) => theme.space.lg};
`;

export const StyledLabel = styled(Type)`
  padding-bottom: ${({ theme }) => theme.space.sm};
`;

export const StyledHeading = styled(Type)`
  padding: ${({ theme }) => theme.space.md} 0 ${({ theme }) => theme.space.sm};
`;
